<div class="container pt-3">
  <div class="text-center mt-3">
    <a href="{{ 'social.media.fb.link' | translate }}" target="_blank" class="px-2">
      <img
        class="social-media-logo"
        [src]="'social-media-icons/facebook.svg' | contentAssetImage"
        draggable="false"
        *notInPopulation="[populations.Hospitality]"
      />
      <img
        class="social-media-logo"
        [src]="'social-media-icons/facebook-corporate.svg' | contentAssetImage"
        draggable="false"
        *inPopulation="[populations.Hospitality]"
      />
    </a>
    <a href="{{ 'social.media.insta.link' | translate }}" target="_blank" class="px-2">
      <img
        class="social-media-logo"
        [src]="'social-media-icons/instagram.svg' | contentAssetImage"
        draggable="false"
        *notInPopulation="[populations.Hospitality]"
      />
      <img
        class="social-media-logo"
        [src]="'social-media-icons/instagram-corporate.svg' | contentAssetImage"
        draggable="false"
        *inPopulation="[populations.Hospitality]"
      />
    </a>
    <a href="{{ 'social.media.x.link' | translate }}" target="_blank" class="px-2">
      <img
        class="social-media-logo"
        [src]="'social-media-icons/x.png' | contentAssetImage"
        draggable="false"
        *notInPopulation="[populations.Hospitality]"
      />
      <img
        class="social-media-logo"
        [src]="'social-media-icons/x-corporate.svg' | contentAssetImage"
        draggable="false"
        *inPopulation="[populations.Hospitality]"
      />
    </a>
    <a href="{{ 'social.media.yt.link' | translate }}" target="_blank" class="px-2">
      <img
        class="social-media-logo"
        [src]="'social-media-icons/youtube.svg' | contentAssetImage"
        draggable="false"
        *notInPopulation="[populations.Hospitality]"
      />
      <img
        class="social-media-logo"
        [src]="'social-media-icons/youtube-corporate.svg' | contentAssetImage"
        draggable="false"
        *inPopulation="[populations.Hospitality]"
      />
    </a>
    <a href="{{ 'social.media.thread.link' | translate }}" target="_blank" class="px-2">
      <img
        class="social-media-logo"
        [src]="'social-media-icons/threads.svg' | contentAssetImage"
        draggable="false"
        *notInPopulation="[populations.Hospitality]"
      />
      <img
        class="social-media-logo"
        [src]="'social-media-icons/threads-corporate.svg' | contentAssetImage"
        draggable="false"
        *inPopulation="[populations.Hospitality]"
      />
    </a>
    <a href="{{ 'social.media.tiktok.link' | translate }}" target="_blank" class="px-2">
      <img
        class="social-media-logo"
        [src]="'social-media-icons/tiktok.svg' | contentAssetImage"
        draggable="false"
        *notInPopulation="[populations.Hospitality]"
      />
      <img
        class="social-media-logo"
        [src]="'social-media-icons/tiktok-corporate.svg' | contentAssetImage"
        draggable="false"
        *inPopulation="[populations.Hospitality]"
      />
    </a>
  </div>
</div>
